import React from "react";
import { makeStyles } from "@mui/styles";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const useStyles = makeStyles({
  fieldElement: {
    margin: "10px 0 10px 0 !important",
  },
});

const DateInput = ({field, index, form_data, handleFieldChange, is_submitting}) => {
  const classes = useStyles();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        autoFocus={index === 0 ? true : false}
        margin="dense"
        id={field.name}
        label={field.label}
        type={field.type}
        defaultValue={dayjs(form_data[field.name])}
        fullWidth
        variant="outlined"
        className={classes.fieldElement}
        onChange={(event) => handleFieldChange({target: {name: field.name, value: dayjs(event).format('YYYY-MM-DD')}})}
        disabled={is_submitting}
      />
    </LocalizationProvider>
  );
}

export default DateInput;
